import styled from 'styled-components';

export const VerifyContainer = styled.div`
  height: 100vh;
  background: ${p => p.theme.palette.white};
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const VerifyContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
  box-sizing: border-box;
  color: rgb(94, 108, 132);
  margin: 0px auto 24px;
  padding: 32px 40px;
  border-radius: 3px;
`;

export const VerifyHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  color: rgb(94, 108, 132);
  font-size: 16px;
`;

export const VerifyDivider = styled.hr`
  width: 50%;
`;

export const VerifyLogo = styled.img`
  width: 94.51px;
  height: 40px;
`;
